import Content from "@components/CustomTypography/Content/Content"
import NewResponsiveImage from "@components/CustomTypography/NewResponsiveImage/NewResponsiveImage"
import Separator, {
	SeparatorType,
} from "@components/CustomTypography/Separator/Separator"
import Typography, {
	Size,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {AdvancedSideAssetMainContent} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./CardWithArrow.module.scss"

type Props = {
	id: number
	data: AdvancedSideAssetMainContent
	container?: SeparatorType
	className?: string
	withImage: boolean
	withWhiteBackground?: boolean
}
const CardWithArrow = (props: Props): JSX.Element => {
	const gradation = {
		0: styles.arrow5,
		1: styles.arrow4,
		2: styles.arrow2,
		3: styles.arrow1,
		4: styles.arrow3,
	}
	// @ts-expect-error
	const arrowStyles = `${styles.arrows} ${gradation[props.id] || ""} ${
		props.withImage ? styles.withImage : ""
	}`

	return (
		<Separator
			className={`${styles.cardContainer}  ${props.className}`}
			withoutMeasure
			{...props.container}
		>
			<div className={arrowStyles}>
				<div className={styles.insideContainer}>
					{props.withImage && props.data.preview && (
						<NewResponsiveImage
							data-testid={"CardWithArrowImage"}
							{...props.data.preview}
							containerClassName={`${styles.imageContainer} ${
								props.withWhiteBackground
									? styles.withWhiteBackground
									: ""
							}`}
							imageClassName={`${styles.image}  ${
								props.withWhiteBackground
									? styles.withWhiteBackground
									: ""
							}`}
							alt={props.data.title ?? props.data.preview?.alt}
						/>
					)}
					{!props.withImage && (
						<Typography
							className={styles.insideTitle}
							content={props.data.upperTitle}
							size={Size.M}
							variant={Variant.Paragraph}
							noPadding
						/>
					)}
				</div>
			</div>
			<div style={{padding: "0 5%"}}>
				<Content
					data={props.data}
					titleProps={{
						size: Size.M,
					}}
					without={{upperTitle: true}}
				/>
			</div>
		</Separator>
	)
}

export default CardWithArrow
